import * as React from 'react';
import { SVGProps } from 'react';

const SvgHold = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#FFD28A" />
    <path
      d="M3.158 20h1.26v-3.057h3.428V20H9.1v-7.046H7.846v2.93H4.418v-2.93h-1.26V20Zm10.293.122c2.06 0 3.34-1.401 3.34-3.642v-.01c0-2.237-1.284-3.638-3.34-3.638-2.05 0-3.345 1.401-3.345 3.638v.01c0 2.24 1.285 3.642 3.345 3.642Zm0-1.094c-1.26 0-2.06-.981-2.06-2.548v-.01c0-1.568.805-2.544 2.06-2.544 1.26 0 2.06.981 2.06 2.544v.01c0 1.552-.785 2.548-2.06 2.548Zm4.346.972h4.458v-1.06h-3.198v-5.986h-1.26V20Zm5.361 0h2.573c2.11 0 3.35-1.309 3.35-3.54v-.01c0-2.226-1.25-3.496-3.35-3.496h-2.573V20Zm1.26-1.064v-4.917H25.6c1.401 0 2.197.864 2.197 2.436v.01c0 1.606-.781 2.47-2.197 2.47h-1.182Z"
      fill="#174174"
    />
  </svg>
);

export default SvgHold;
